export const CONTACT_EMAIL = "andresguedez00@gmail.com";

export const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = (path) => `${API_BASE}/api${path}`;
